<template>
    <div>
        <div
            v-for="(data, consentIdx) in consents"
            :key="consentIdx"
            class="mb-2"
        >
            <div
                class="consent-row richTable-row"
                :class="{
                    'richTable-title is-sm font-weight-normal': mode === 'modal'
                }"
                v-if="!data.isAdditionalConsent"
            >
                <div
                    style="word-break: break-word;"
                    :id="`#collapse-${data.consent_id}`"
                    v-html="setContent(data)"
                />
                <div
                    v-for="(param, paramIdx) in data.dict_consents.params"
                    :key="paramIdx"
                    class="consent-params"
                >
                    <phone-input
                        v-if="param.tag === '$$$$CONTACT_PHONE$$$$'"
                        placeholder="Nr telefonu"
                        :phone-value="param.value"
                        :invalid-phone="param.invalid"
                        :readonly="true"
                        @setInvalidPhoneValue="setInvalidPhoneValue($event, param, data)"
                        @onChange="onChangeParams($event, param, data)"
                    />
                    <the-input
                        v-else-if="param.tag === '$$$$CONTACT_EMAIL$$$$'"
                        type="email"
                        label="Adres e-mail"
                        :invalid="param.invalid"
                        :invalid-feedback="param.invalid ? 'Niepoprawny adres e-mail' : ''"
                        :text="param.value"
                        :readonly="true"
                        @input="onChangeParams($event, param, data)"
                    />
                </div>
                <div class="richTable-col mt-3" style="--width-md: 100%">
                    <div class="custom-control custom-checkbox custom-checkbox-lg pl-3">
                        <ui-checkbox-input
                            :name="`consent-${data.consent_id}`"
                            :value="selectedConsent(data)"
                            :label="data.dict_consents.name"
                            @change="val => checkConsent(val, data)"
                        />
                        <ui-checkbox-input
                            v-if="isAdditionalConsent(data)"
                            :name="
                                `consent-${
                                    setAdditionalConsent.consent_id
                                }`
                            "
                            class="mt-2"
                            :value="selectedConsent(setAdditionalConsent)"
                            :label="
                                setAdditionalConsent.dict_consents.name
                            "
                            @change="
                                val =>
                                    checkConsent(
                                        val,
                                        setAdditionalConsent
                                    )
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UiCheckboxInput } from '../global/ui'
export default {
    components: { UiCheckboxInput },
    props: {
        consents: {
            type: Array,
            required: true
        },
        mode: {
            type: String,
            default: 'settings'
        }
    },
    beforeMount() {
        this.consents.forEach(el => {
            if (!el.state) {
                this.$store.dispatch('setConsentState', {
                    id: el.consent_id,
                    state: 'N'
                })
            }
        })
    },
    methods: {
        checkConsent(val, data) {
            const state = val ? 'Y' : 'N'
            this.$store.dispatch('setConsentState', {
                id: data.consent_id,
                state
            })
        },
        isAdditionalConsent(data) {
            return data.dict_consents.code.includes('directMarketing') &&
                this.consents.find(
                    el => el.dict_consents.code === this.setAdditionalConsent.dict_consents.code
                )
        },
        selectedConsent(data) {
            return this.$store.getters.getConsentById(data.consent_id)
        },
        setInvalidPhoneValue(val, param, data) {
            param.invalid = val
            const additionalConsent = this.isAdditionalConsent(data)
            if (additionalConsent) {
                const additionalConsentParam = additionalConsent.dict_consents.params.find(
                    el => el.tag === param.tag
                )
                additionalConsentParam.invalid = val
            }
        },
        onChangeParams(val, param, data) {
            const invalid = param.tag === '$$$$CONTACT_EMAIL$$$$'
                ? !this.isEmailFormat(val)
                : param.invalid
            this.$store.dispatch('setConsentParams', {
                id: data.consent_id,
                param: [{
                    ...param,
                    value: val,
                    invalid
                }]
            })
            const additionalConsent = this.isAdditionalConsent(data)
            if (additionalConsent) {
                const additionalConsentParam = additionalConsent.dict_consents.params.find(
                    el => el.tag === param.tag
                )
                this.$store.dispatch('setConsentParams', {
                    id: additionalConsent.consent_id,
                    param: [{
                        ...additionalConsentParam,
                        value: val,
                        invalid
                    }]
                })
            }
        },
        setContent(consent) {
            let content = consent.dict_consents.content.split('$$$$')[0]
            if (consent.dict_consents.params?.length) {
                if (content.slice(-1) === ' ') {
                    content = content.slice(0, -1)
                }
                content += ':'
            }
            return content
        },
        isEmailFormat(val) {
            // eslint-disable-next-line
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return regex.test(val)
        }
    },
    computed: {
        setAdditionalConsent() {
            return this.consents.find(
                el => {
                    const values = ['Sms', 'directMarketing']
                    return values.every(term => el.dict_consents.code.includes(term))
                }
            )
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.consent-params{
    padding-top: 1.5rem;

    .form-control {
        width: 20rem;
        max-width: 100%;
    }

    > * {
        max-width: 100%;
    }
    @include media-breakpoint-down(sm) {
        width: 100%;
        .form-control {
            width: 100%;
        }
    }
}
</style>
